import { atom } from "recoil";
import { ocPersistAtom } from "./persist-atom";

export const ocCustomerLicencesState = atom({
  key: "ocCustomerLicencesState",
  default: {
    company: "001",
    myHR: true,
    myHRChangeData: true,
    myLeave: true,
    myLeaveEmployeeRequests: true,
    myCafeteria: false,
    myTime: false,
    myTimeEmployeeRequests: false,
  },
  effects_UNSTABLE: [ocPersistAtom],
});
